import { customerApi } from "../config";

export const postCustomerProfile = async (customerProfileData) => {
  return await customerApi.put("/customer/profile", customerProfileData);
};

export const getCustomerProfile = async() =>{
    return await customerApi.get('/customer/profile')
}
